import { render, staticRenderFns } from "./Banners.vue?vue&type=template&id=83be44e4&"
import script from "./Banners.vue?vue&type=script&lang=js&"
export * from "./Banners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83be44e4')) {
      api.createRecord('83be44e4', component.options)
    } else {
      api.reload('83be44e4', component.options)
    }
    module.hot.accept("./Banners.vue?vue&type=template&id=83be44e4&", function () {
      api.rerender('83be44e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Affiliates/Banners.vue"
export default component.exports